import { render, staticRenderFns } from "./MediaNameTag.vue?vue&type=template&id=bfcb5278&scoped=true&"
import script from "./MediaNameTag.vue?vue&type=script&lang=js&"
export * from "./MediaNameTag.vue?vue&type=script&lang=js&"
import style0 from "./MediaNameTag.vue?vue&type=style&index=0&id=bfcb5278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfcb5278",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
